export const mainNavigationHeightMobile = "100px"
export const mainNavigationHeightDesktop = "100px"
